export const COUNTRY = "country";
export const DATE = "date";
export const DURATION = "duration";
export const FEATURE = "feature";
export const HIGHLIGHTS = "highlights";
export const ORGANIZER = "organizer";
export const PRICE = "price";
export const REGION = "region";
export const THEME = "theme";
export const TRIP_ID = "trip_id";
export const TRIP_TYPE = "trip_type";
